import { Flex } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";

// 类型定义
interface LinkItem {
  text: string;
  url: string;
}

// 底部链接
const FooterLinks = ({ settingObj, footerDrawerRef }: any) => {
  return (
    <Flex
      align="center"
      justify="center"
      wrap={false}
      gap={16}
      className="footer-content"
    >
      <Flex align="center" wrap={false} gap={16} className="footer-link">
        {settingObj?.links?.map((item: LinkItem, index: number) => {
          return (
            <a
              key={index}
              className="action-text"
              target="_blank"
              rel="noreferrer"
              href={item.url || "#"}
              onClick={!item.url ? (e) => e.preventDefault() : undefined}
            >
              {item.text}
            </a>
          );
        })}
      </Flex>
      {settingObj?.links && settingObj?.links?.length > 0 && (
        <DoubleRightOutlined
          onClick={() => footerDrawerRef?.current?.setVisit(true)}
          style={{ flexShrink: 0, cursor: "pointer" }}
        />
      )}
    </Flex>
  );
};

export default FooterLinks;
